import api from '../services/api'
import { RESET } from '../redux/game'
import { TEAM_CHANGED } from '../redux/team'

// Actions
const FETCHING_FINANCIALS_START = 'ascension/financials/fetching'
const FETCHING_FINANCIALS_SUCCESS = 'ascension/financials/success'
const FETCHING_FINANCIALS_ERROR = 'ascension/financials/error'
const FINANCIALS_CHANGE_PAGE = 'ascension/financials/changepage'

// Reducer
const initialState = {
  currentPage: 0,
  isLoading: false,
  isLoaded: false,
  error: null,
  financials: {}
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_FINANCIALS_START: {
      return {
        ...state,
        isLoading: true,
        financials: {
          ...state.financials,
          [`${action.data.round}`]: null
        },
        error: null
      }
    }
    case FETCHING_FINANCIALS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        financials: {
          ...state.financials,
          [`${action.data.round}`]: action.data.financials
        }
      }
    }
    case FETCHING_FINANCIALS_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case FINANCIALS_CHANGE_PAGE: {
      return {
        ...state,
        currentPage: action.data
      }
    }
    case RESET:
    case TEAM_CHANGED: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingFinancialsStart (round) {
  return {
    type: FETCHING_FINANCIALS_START,
    data: { round }
  }
}

export function fetchingFinancialsSuccess (financials, round) {
  return {
    type: FETCHING_FINANCIALS_SUCCESS,
    data: { financials, round }
  }
}

export function fetchingFinancialsError (error) {
  return {
    type: FETCHING_FINANCIALS_ERROR,
    data: error
  }
}

export function updatePage (page) {
  return {
    type: FINANCIALS_CHANGE_PAGE,
    data: page
  }
}

// Action Creators
export function fetchFinancials (team, round) {
  return async (dispatch) => {
    dispatch(fetchingFinancialsStart(round))

    try {
      const response = await api.getFinancials(team, round)
      dispatch(fetchingFinancialsSuccess(response, round))
    } catch (e) {
      dispatch(fetchingFinancialsError(e))
    }
  }
}
